var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',[_c('h3',{staticClass:"storefront-title no-select"},[_vm._v(_vm._s(_vm.title))])]):_c('div',[_c('div',{staticClass:"text-ui-placeholder hide-on-mobile"})])])}
var staticRenderFns = []

export { render, staticRenderFns }